import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Chart from "../../Components/TemperatureChart";
import Title from "../../Components/Title";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import { formatTimeWithTZOffset, getToken } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";

const server = EnvSettings.server;

function formatChartData(data) {
  var retdata = [];
  data.forEach((element) => {
    retdata.push({
      tempOne:
        element.tempOne && element.tempOne !== 8500
          ? element.tempOne / 100.0
          : null,
      tempTwo:
        element.tempTwo && element.tempTwo !== 8500
          ? element.tempTwo / 100.0
          : null,
      tempThree:
        element.tempThree && element.tempThree !== 8500
          ? element.tempThree / 100.0
          : null,
      timeStamp: formatTimeWithTZOffset(element.timeStamp),
    });
  });
  return retdata;
}

export default function ChartContainer(props) {
  const classes = useStyles();
  const [chartData, setChartData] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const getChartData = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: getToken() }),
      };
      fetch(server + "/get_transportation_data", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            setChartData(result.transport);
          }
        });
    };
    getChartData();
  }, [dispatch]);

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper} style={{ height: 300 }}>
        {chartData ? (
          <Chart
            props={{ ...props }}
            data={{
              chartData: formatChartData(chartData.Measurements),
              title: formatTimeWithTZOffset(chartData.startTime),
              deviceConfig: chartData.Device.DeviceConfig,
            }}
          />
        ) : (
          <Title>{t("dashboard.noData")}</Title>
        )}
      </Paper>
    </Grid>
  );
}
